import React from 'react';

import MenuBar from './MenuBar';
import PageLoader from './PageLoader';

export default function (props) {

    return (
        <React.Fragment>

            <MenuBar />

            <div className="container">

                <PageLoader showSpinner={props.showSpinner} />
                
                <div className="p-grid">
                    <div className="p-col-12 p-md-8" >
                        <h1>{props.title}</h1>
                    </div>
                    <div className="p-col-12 p-md-4" >
                        {props.buttonAditional}
                    </div>
                </div>
                
                <div>
                    {props.children}
                </div>

            </div>

            <div className="footerPagina" />

        </React.Fragment>
    );
};
